export const sessionMessages = {
  "browser.viewport.emulationHint": "Reloads with mobile identity, touch and pixel density. Browser engine, keyboard and system bars are not simulated.",
  "browser.viewport.emulationUnavailable": "Device emulation requires a native desktop Web preview.",
  "sessionList.filter.includeMainSessions": "Main sessions",
  "sessionList.filter.includeSubsessions": "Subsessions",
  "session.pruning.maintenance_required": "The session or its storage is busy. Wait for the current operation to finish, then retry cleanup.",
  "session.pruning.unavailable": "The cleanup plugin is unavailable or did not respond. Reopen CodeNomad and retry.",
  "session.pruning.conflict": "The message changed since it was selected. Reload it and select the content again.",
  "session.pruning.not_deletable": "The selected content cannot be deleted. Only completed tools and reasoning in this session can be removed.",
  "session.pruning.unsupported_storage": "The cleanup plugin could not validate this session's storage. Cleanup was refused.",
  "session.pruning.blocked": "Cleanup was not confirmed. The pruning plugin may be unavailable, live cleanup may be disabled, or the message may have changed. Reload the message before retrying.",
  "sessionPicker.title": "OpenCode • {folder}",
  "sessionPicker.empty.noPrevious": "No previous sessions",
  "sessionPicker.resume.title": "Resume a session ({count}):",
  "sessionPicker.session.untitled": "Untitled",
  "sessionPicker.divider.or": "or",
  "sessionPicker.new.title": "Start new session:",
  "sessionPicker.agents.loading": "Loading agents...",
  "sessionPicker.actions.creating": "Creating...",
  "sessionPicker.actions.createSession": "Create Session",
  "sessionPicker.actions.cancel": "Cancel",

  "sessionList.header.title": "Sessions",
  "sessionList.session.untitled": "Untitled",
  "sessionList.status.working": "Working",
  "sessionList.status.compacting": "Compacting",
  "sessionList.status.idle": "Idle",
  "sessionList.childActivity.permission.one": "{count} subsession needs input",
  "sessionList.childActivity.permission.other": "{count} subsessions need input",
  "sessionList.childActivity.working.one": "{count} subsession working",
  "sessionList.childActivity.working.other": "{count} subsessions working",
  "sessionList.childActivity.compacting.one": "{count} subsession compacting",
  "sessionList.childActivity.compacting.other": "{count} subsessions compacting",
  "sessionList.childActivity.idle.one": "{count} subsession idle",
  "sessionList.childActivity.idle.other": "{count} subsessions idle",
  "sessionList.status.interrupted": "Interrupted",
  "sessionList.status.retrying": "Retrying",
  "sessionList.status.retryingIn": "Retrying in {seconds}s",
  "sessionList.status.retryTooltip": "{message} (Attempt {attempt})",
  "sessionList.status.retryToast": "{countdown}: {message} (Attempt {attempt})",
  "sessionList.status.needsPermission": "Needs Permission",
  "sessionList.status.needsInput": "Needs Input",
  "sessionList.expand.collapseAriaLabel": "Collapse session",
  "sessionList.expand.expandAriaLabel": "Expand session",
  "sessionList.expand.collapseTitle": "Collapse",
  "sessionList.expand.expandTitle": "Expand",
  "sessionList.expand.withChildActivity": "{action} — {activity}",
  "sessionList.actions.newSession.ariaLabel": "New session",
  "sessionList.actions.newSession.title": "New session",
  "sessionList.actions.copyId.ariaLabel": "Copy session ID",
  "sessionList.actions.copyId.title": "Copy session ID",
  "sessionList.actions.reload.ariaLabel": "Reload session",
  "sessionList.actions.reload.title": "Reload session",
  "sessionList.actions.rename.ariaLabel": "Rename session",
  "sessionList.actions.rename.title": "Rename session",
  "sessionList.actions.delete.ariaLabel": "Delete session",
  "sessionList.actions.delete.title": "Delete session",
  "sessionList.copyId.success": "Session ID copied",
  "sessionList.copyId.error": "Unable to copy session ID",
  "sessionList.reload.error": "Unable to reload session",
  "sessionList.delete.error": "Unable to delete session",
  "sessionList.delete.title": "Delete session",
  "sessionList.delete.confirmMessage": "Delete \"{label}\"? This cannot be undone.",
  "sessionList.delete.confirmLabel": "Delete",
  "sessionList.delete.cancelLabel": "Cancel",
  "sessionList.rename.error": "Unable to rename session",

  "sessionList.filter.placeholder": "Search sessions…",
  "sessionList.filter.ariaLabel": "Search sessions",
  "sessionList.history.back": "Back",
  "sessionList.history.backTitle": "Back to the previous conversation",
  "sessionList.history.forward": "Forward",
  "sessionList.history.forwardTitle": "Forward to the next conversation",
  "sessionList.sort.ariaLabel": "Sort sessions",
  "sessionList.sort.activity": "Activity",
  "sessionList.sort.name": "Name",
  "sessionList.sort.worktree": "Worktree",
  "sessionList.worktreeFilter.ariaLabel": "Filter sessions by worktree",
  "sessionList.worktreeFilter.all": "All worktrees",
  "sessionList.worktree.tooltip": "Worktree: {worktree}",
  "sessionList.worktree.workspace": "Workspace",
  "sessionList.worktreeMove.error": "Unable to move session family",
  "sessionList.loading.more": "Loading more sessions…",
  "sessionList.loading.initial": "Loading sessions…",
  "sessionList.loadError.title": "Unable to load sessions",
  "sessionList.loadError.detail": "OpenCode did not return the session list.",
  "sessionList.loadError.retry": "Retry",
  "sessionList.selection.selectAllLabel": "Select all",
  "sessionList.selection.selectAllAriaLabel": "Select all sessions",
  "sessionList.selection.clearLabel": "Clear",
  "sessionList.selection.clearAriaLabel": "Clear selection",
  "sessionList.selection.checkboxAriaLabel": "Select session",
  "sessionList.bulkDelete.button": "Delete {count}",
  "sessionList.bulkDelete.ariaLabel": "Delete {count} selected sessions",
  "sessionList.bulkDelete.title": "Delete sessions",
  "sessionList.bulkDelete.confirmMessage": "Delete {count} selected sessions? This cannot be undone.",
  "sessionList.bulkDelete.confirmLabel": "Delete",
  "sessionList.bulkDelete.cancelLabel": "Cancel",
  "sessionList.bulkDelete.error": "Unable to delete {count} sessions",

  "sessionRenameDialog.title": "Rename Session",
  "sessionRenameDialog.description.withLabel": "Update the title for \"{label}\".",
  "sessionRenameDialog.description.default": "Set a new title for this session.",
  "sessionRenameDialog.input.label": "Session name",
  "sessionRenameDialog.input.placeholder": "Enter a session name",
  "sessionRenameDialog.actions.cancel": "Cancel",
  "sessionRenameDialog.actions.rename": "Rename",
  "sessionRenameDialog.actions.renaming": "Renaming…",

  "sessionView.fallback.sessionNotFound": "Session not found",
  "sessionView.alerts.abortFailed.message": "Failed to stop session",
  "sessionView.alerts.abortFailed.title": "Stop failed",
  "sessionView.alerts.revertFailed.message": "Failed to revert to message",
  "sessionView.alerts.revertFailed.title": "Revert failed",
  "sessionView.alerts.deleteUpToFailed.message": "Failed to delete messages",
  "sessionView.alerts.deleteUpToFailed.title": "Delete failed",
  "sessionView.alerts.forkFailed.message": "Failed to fork session",
  "sessionView.alerts.forkFailed.title": "Fork failed",
  "sessionView.attachments.expandPastedTextAriaLabel": "Expand pasted text",
  "sessionView.attachments.insertPastedTextTitle": "Insert pasted text",
  "sessionView.attachments.removeAriaLabel": "Remove attachment",

  "sessionPreview.title": "Web preview",
  "sessionPreview.backToChat": "Back to chat",
  "sessionPreview.close": "Close preview",
  "sessionPreview.chat.button": "Back to chat",
  "sessionPreview.forward": "Forward",
  "sessionPreview.open.button": "Open web preview",
  "sessionPreview.open.title": "Open web preview",
  "sessionPreview.open.prompt": "Enter a trusted local or staging URL to preview in this session.",
  "sessionPreview.open.label": "Preview URL",
  "sessionPreview.open.invalidUrl": "Enter a valid HTTP or HTTPS URL.",
  "sessionPreview.open.placeholder": "https://staging.example.com",
  "sessionPreview.open.confirm": "Open preview",
  "sessionPreview.open.cancel": "Cancel",
  "sessionPreview.comment.mode": "Comment mode",
  "sessionPreview.comment.title": "Add preview comment",
  "sessionPreview.comment.prompt": "Describe what should change for the selected element.",
  "sessionPreview.comment.label": "Comment",
  "sessionPreview.comment.add": "Add comment",
  "sessionPreview.comment.cancel": "Cancel",
  "browserFrame.viewport": "Viewport size",
  "browserFrame.viewport.responsive": "Responsive viewport",
  "browserFrame.viewport.desktop": "Desktop viewport (1440 x 900)",
  "browserFrame.viewport.tablet": "Tablet viewport (768 x 1024)",
  "browserFrame.viewport.tabletLandscape": "Tablet landscape (1024 x 768)",
  "browserFrame.viewport.mobile": "Mobile viewport (390 x 844)",
  "browserFrame.viewport.mobileLandscape": "Mobile landscape (844 x 390)",

  "sessionEvents.sessionCompactedToast": "Session {label} was compacted",
  "sessionEvents.notify.needsInput": "Session “{label}” needs your answer",
  "sessionEvents.notify.done": "Session “{label}” finished",
  "sessionEvents.sessionError.unknown": "Unknown error",
  "sessionEvents.sessionError.title": "Session error",
  "sessionEvents.sessionError.message": "Error: {message}",

  "sessionState.cleanup.deepConfirm.message": "This cleanup may be slow, and may delete sessions you didn't intend to delete. Are you sure?",
  "sessionState.cleanup.deepConfirm.title": "Deep Clean Sessions",
  "sessionState.cleanup.deepConfirm.detail": "Deep Clean Sessions will delete all sessions that have no messages, remove any finished sub-agent sessions, and clear out any unused forks of a session.",
  "sessionState.cleanup.deepConfirm.confirmLabel": "Continue",
  "sessionState.cleanup.deepConfirm.cancelLabel": "Cancel",
  "sessionState.cleanup.toast.one": "Cleaned up {count} blank session",
  "sessionState.cleanup.toast.other": "Cleaned up {count} blank sessions",
} as const
